export const currentVersion = '4.6.5';
export const CURRENT_GRAPH_VERSION = '2.2.10';
